// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { ProductFilterSolution } from "../../../../common/interfaces/conversionworld/ProductFilter";
import InlineSVG from "../../../../components/inline_svg/InlineSVG";

@Component({
  mixins: [template],
  components: {
    InlineSVG,
  },
})
export default class Solution extends Vue {
  @Prop({ default: false })
  public useKonsiFilter!: boolean;

  get filterStore() {
    if (this.useKonsiFilter) {
      return this.$store.conversionWorldKonsiFilter;
    }

    return this.$store.conversionWorldProductFilter;
  }

  get branchen() {
    if (this.filterStore.filterData) {
      return this.filterStore.filterData.branchen
        .filter(
          (x) =>
            x.count > 0 && x.solutions.filter((y) => y.count > 0).length > 0
        )
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    return [];
  }

  private isChecked(solution: ProductFilterSolution) {
    return this.filterStore.filter.solutions.indexOf(solution.id) >= 0;
  }

  private onInput(solution: ProductFilterSolution, value) {
    if (value) {
      if (!this.isChecked(solution)) {
        this.filterStore.addFilterTag("solutions", solution);
      }
    } else {
      this.filterStore.removeFilterTag("solutions", solution);
    }
  }
}
